import { connect } from 'react-redux';
import { isVenueDashboardSubtypeFoodAndBeverage } from 'helpers/ia-logic';
import { selectActiveVenue } from 'selectors/general';
import RatingsInstructorFilter from './RatingsInstructorFilter';
import { selectRatingsInstructors, selectSelectedInstructorId } from './Ratings.selectors';
import { updateInstructor } from './Ratings.saga';

const mapStateToProps = state => ({
  instructors: selectRatingsInstructors(state),
  selectedInstructorId: selectSelectedInstructorId(state),
  isVenueFoodAndBeverage: isVenueDashboardSubtypeFoodAndBeverage(selectActiveVenue(state)),
});

const mapDispatchToProps = { updateInstructor };

export default connect(mapStateToProps, mapDispatchToProps)(RatingsInstructorFilter);
